export interface CozeSessionUpdateOptions {
  longestSilenceMs?: number;
  voiceId?: string;
}

/** 仅需 sendMessage，避免 RealtimeClient 私有字段导致的结构类型不兼容 */
export interface CozeSessionUpdateClient {
  sendMessage(message: Record<string, unknown>): Promise<void>;
}

/**
 * 建连成功后发送 Coze Realtime 上行事件 session.update。
 * 用于调大 longest_silence_ms，避免拍课长静默触发 4029 断连（默认 3 分钟）。
 */
export async function applyCozeSessionUpdate(
  client: CozeSessionUpdateClient,
  options: CozeSessionUpdateOptions
): Promise<void> {
  const data: Record<string, unknown> = {};

  if (
    typeof options.longestSilenceMs === 'number' &&
    options.longestSilenceMs > 0
  ) {
    data.longest_silence_ms = options.longestSilenceMs;
  }

  if (options.voiceId && options.voiceId.trim()) {
    data.voice_id = options.voiceId.trim();
  }

  if (Object.keys(data).length === 0) {
    return;
  }

  await client.sendMessage({
    id: `session_update_${Date.now()}`,
    event_type: 'session.update',
    data,
  });
}

export const DEFAULT_LONGEST_SILENCE_MS = 3600000;
